import React from 'react'

const Names = () => {
    return (
        <ul className="header-names">
            <li>ROCK</li>
            <li>PAPER</li>
            <li>SCISSORS</li>
            <li>LIZARD</li>
            <li>SPOCK</li>
        </ul>
        );
}

export default Names